import { Directive, ElementRef, Optional, Inject, Output, EventEmitter, OnInit, OnDestroy, Input } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { filter, takeUntil, throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[outsideClick]',
})
export class OutsideClickDirective implements OnInit, OnDestroy {
  @Output('outsideClick') outsideClick = new EventEmitter<MouseEvent>();
  @Input()
  public exclude: HTMLElement[] = [];

  private destroyed = new Subject<void>();

  constructor(private element: ElementRef, @Optional() @Inject(DOCUMENT) private document: any) {}

  ngOnInit() {
    fromEvent<MouseEvent>(this.document, 'mousedown')
      .pipe(
        throttleTime(100),
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return !this.isOrContainsClickTarget(this.element.nativeElement, clickTarget);
        }),
        takeUntil(this.destroyed)
      )
      .subscribe(event => this.outsideClick.emit());
  }

  private isOrContainsClickTarget(element: HTMLElement, clickTarget: HTMLElement) {
    for (const el of this.exclude) {
      if (el === clickTarget) {
        return true;
      }
    }
    return element == clickTarget || element.contains(clickTarget);
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
